import React, { useMemo } from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import JfrogXrayMappingForm from './JfrogXrayMappingForm';
import JfrogXrayCredentialForm from './JfrogXrayCredentialForm';
import { CellRenderers } from 'utils/tableUtils';
import { Tooltip } from 'antd';
import { HelpIcon } from 'components/Icons';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import JfrogXrayMappingFormV2 from './JfrogXrayMappingFormV2';
import { columnRenderArrayData } from "utils/tableUtils";

export default function JfrogXrayConfigListing(props){
    const featureFlags = useFeatureFlag();
    const columns = useMemo(() => [
    {
        title: "Project",
        dataIndex: "projectName",
        width: 240,
    }, {
        title: "Project Repositories",
        dataIndex: "projectRepos",
        width: 200,
        render: (projectRepos, record) => {
            return projectRepos ? projectRepos.includes(",") ? columnRenderArrayData(projectRepos) : projectRepos : 'ALL'
        } 
    },
    {
        title: "Builds",
        dataIndex: "buildName",
        width: 240,
        render: columnRenderArrayData
    },
    {
        title: <>Historical Data Range (in Days) <Tooltip title={"N/A represents that Armorcode will pull all the data from Jfrog Xray"}><HelpIcon /></Tooltip></>,
        dataIndex: "dateRange",
        width: 100,
        render: CellRenderers.VALUE_OR_NA   
    }
  ],[])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={featureFlags.JFROG_XRAY_FETCH_REPOSITORY ? JfrogXrayMappingFormV2 : JfrogXrayMappingForm}
            CredentialsForm={JfrogXrayCredentialForm}
            extraColumns={columns}
            displayComponentName={featureFlags.JFROG_XRAY_FETCH_REPOSITORY ? "Repositories" : "Projects" }
        />
    )
}